<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <!--右侧内容-->
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      <span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>课程
    </div>
    <div class="class_add_con">
      <form data-vv-scope="form">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr class="tita">
            <td class="left_td">课程信息</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td class="left_td pt30">课程名称(60字以内)：</td>
            <td class="pt20">
              <input type="text" name="name" id="name" v-validate="'required'" v-model="params.name" placeholder="60字以内" v-bind:maxlength="60" class="put_495" />
              <div class="error_msg_tip">{{ errors.first('form.name') }}</div>
            </td>
          </tr>
          <tr>
            <td class="left_td">课程编码：</td>
            <td>
              <input type="text" name="code" v-model="params.code" class="put_240" />
              <!--<div class="error_msg_tip">{{ errors.first('form.code') }}</div>-->
            </td>
          </tr>
          <tr>
            <td class="left_td">授课方式：</td>
            <td>
              <input name="online" type="radio" value="1" v-model="params.online"/>
              线上　　　
              <input name="online" type="radio" value="0" v-model="params.online"/>
              线下</td>
          </tr>
          <tr v-if="params.online=='1'">
            <td class="left_td" valign="top">
              课程章节：
              (可拖动调整章节顺序)
            </td>
            <td :style="scrollBox">
              <!--p class="rdiv" v-if="!noEdit" v-for="item in currentChapterList" :key="item.id"  v-dragging="{ item: item, list: currentChapterList }"-->
              <p class="rdiv" v-if="!noEdit" v-for="item in currentChapterList" :key="item.id">
                <a href="javascript:void(0);" class="del" @click="delRSelectedId(currentChapterList, params.chapterList, item.id)">删除</a>
                <table width="497" border="0" cellspacing="0" cellpadding="0" class="mt10 zj_list">
                  <tr>
                    <td width="55"  valign="top" class="td_bg"></td>
                    <td width="191"  valign="top" class="td_bg">{{item.name}}</td>
                    <td width="100"  valign="top" class="td_bg">类型：
                      <span v-for='i in Dropdown.state.resourceType' :key="i.value" :value="i.value" v-if="item.type === i.value">{{i.label}}</span>
                      <span v-if="item.type == '4'">测验</span>
                    </td>
                    <td valign="top" align="right">
                      <img :src="item.cover" v-if="item.cover" width="110" height="110" />
                      <img src="@/assets/images/test_img.jpg" v-if="!item.cover" width="110" height="110">
                      <a style="cursor: pointer; text-decoration: underline;" @click="toSource(item.type, item.businessId)">{{item.title}}</a>
                    </td>
                  </tr>
                </table>
              </p>
              <p class="rdiv" v-if="noEdit" v-for="item in currentChapterList" :key="item.id">
              <table width="497" border="0" cellspacing="0" cellpadding="0" class="mt10 zj_list">
                <tr>
                  <td width="55"  valign="top" class="td_bg"></td>
                  <td width="191"  valign="top" class="td_bg">{{item.name}}</td>
                  <td width="100"  valign="top" class="td_bg">类型：
                    <span v-for='i in Dropdown.state.resourceType' :key="i.value" :value="i.value" v-if="item.type === i.value">{{i.label}}</span>
                    <span v-if="item.type == '4'">测验</span>
                  </td>
                  <td valign="top" align="right">
                    <img :src="item.cover" v-if="item.cover" width="110" height="110" />
                    <img src="@/assets/images/test_img.jpg" v-if="!item.cover" width="110" height="110">
                    <a style="cursor: pointer; text-decoration: underline;" @click="toSource(item.type, item.businessId)">{{item.title}}</a>
                  </td>
                </tr>
              </table>
              </p>
              <table v-if="!noEdit" width="497" border="0" cellspacing="0" cellpadding="0" class="mt10 zj_list">
                <tr>
                  <td width="210"  valign="top"><input type="text" name="textfield" id="textfield" v-model="chapterName" placeholder="填写名称" class="put_495 w244" /></td>
                  <td valign="top" class="col_2">
                    <a href="javascript:void(0);"  @click="showResourceSelect()" class="add_bt_all">添加资源</a><br />
                    <a href="javascript:void(0);" @click="showExamSelect" class="add_bt_all col_2">添加测验</a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td class="left_td pt30">课程分类：</td>
            <td class="pt20">
              <input type="hidden" name="classification" id="classification" v-model="params.courseClassifiId" v-validate="'required'">
              <div class="treeSelect">
                <treeselect
                  :options="options"
                  :value="params.courseClassifiId"
                  :searchable="false"
                  :show-count="true"
                  placeholder="--请选择分类--"
                  v-model="params.courseClassifiId"
                >
                </treeselect>
                <i class="add_iconfont" @click="addCC()"></i>
              </div>
              <div class="error_msg_tip">{{ errors.first('form.classification') }}</div>
            </td>
          </tr>
          <tr>
            <td class="left_td">课程封面：</td>
            <td class="rdiv pt20">
              <input type="hidden" v-model="params.faceUrl" name="faceUrl" v-validate="'required'">
              <img v-if="params.faceUrl && params.faceUrl!==''" :src="params.faceUrl"  class="upload_img" />
              <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'faceUrl'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS>
              <p class="mt10"><span class="tips_text">建议图片长280px宽150px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
              <div class="error_msg_tip">{{ errors.first('form.faceUrl') }}</div>
            </td>
          </tr>
          <tr>
            <td class="left_td pt30" valign="top">课程简介：</td>
            <td valign="top" class="pt30 rdiv">
              <textarea name="title" id="title" cols="" rows="" class="text_area w490 h70" v-model="params.title" v-validate="'required'" v-bind:maxlength="200" placeholder="200字以内"></textarea>
              <div class="error_msg_tip">{{ errors.first('form.title') }}</div>
            </td>
          </tr>
          <tr>
            <td class="left_td pt30" valign="top">课程描述：</td>
            <td valign="top" class="pt30">
              <Ueditor :value="ueditor.value" :config="ueditor.config" ref="ue"></Ueditor>
              <br><br>
            </td>
          </tr>
          <tr>
            <td class="left_td" valign="top">附件：</td>
            <td valign="top">
              <upload-o-s-s-elem v-if="uploadOSSConf_C.STS!=null" :files="uploadFiles" :uploadOSSConf="uploadOSSConf_C" @success = "OSSUploadCSuccess" @remove="handleRemove" @preview="handlePreview"></upload-o-s-s-elem>
            </td>
          </tr>
          <tr>
            <td class="left_td pt30" valign="top">课程讲师：</td>
            <td class="pt30">
              <dl class="js_man" v-for="item in teacherList" :key="item.id">
                <a class="all_del_icon" @click="delTSelectedId(currentTCIds, item.id)"></a>
                <dt>
                  <img src="@/assets/images/teacher-avatar.png" width="166" height="166" v-if="!item.faceUrl || item.faceUrl == ''" />
                  <img :src="item.faceUrl" v-if="item.faceUrl && item.faceUrl !== ''" width="166" height="166">
                </dt>
                <dd>{{item.name}}</dd>
              </dl>
              <div class="clear"></div>
              <p><a href="javascript:void(0);" @click="addTeacher(currentTCIds)" class="add_bt_all mt5">添加讲师</a><br /></p></td>
          </tr>
          <tr class="tita">
            <td class="left_td">课程设置</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td class="left_td " valign="top" style="padding-top:20px;">推送范围(显示到前台"任务"列表中)：</td>
            <td class="pt20" valign="top">
              <p>
                <input name="see" type="radio" value="2" v-model="params.publicState"/>
                全员
                <input name="see" type="radio" value="1" v-model="params.publicState"/>
                指定人员
                <input name="see" type="radio" value="0" v-model="params.publicState"/>
                无
              </p>
              <!--指定人员-->
              <dl class="qa_man_add" v-if="params.publicState == '1'">
                <dt><a href="javascript:void(0);" @click="showRange" class="on">+选择</a></dt>
                <dd v-if="publicStateList.length > 0">
                  已选标签{{ rangePermission.getPersonTypes(publicStateList).tags}}个,
                  已选用户{{ rangePermission.getPersonTypes(publicStateList).users}}个,
                  已选人员{{ rangePermission.getPersonTypes(publicStateList).members}}个,
                  已选部门{{ rangePermission.getPersonTypes(publicStateList).depts}}个
                  <!--span v-for="item in publicStateList" :key="item.id" style="background: none; height: 36px; line-height: 36px; text-align: center; width: auto; margin-bottom: 0; margin-left: 0;">{{item.name}}</span-->
                </dd>
              </dl>
              <!--/指定人员--></td>
          </tr>
          <tr>
            <td class="left_td " valign="top" style="padding-top:20px;">可见范围(显示到前台"课程"列表中)：</td>
            <td class="pt20" valign="top">
              <p>
                <input name="see2" type="radio" value="2" v-model="params.scope"/>
                全员
                <input name="see2" type="radio" value="1" v-model="params.scope"/>
                指定人员
                <input name="see2" type="radio" value="0" v-model="params.scope"/>
                无
              </p>
              <!--指定人员-->
              <dl class="qa_man_add" v-if="params.scope == '1'">
                <dt><a href="javascript:void(0);" @click="showScope" class="on">+选择</a></dt>
                <dd v-if="scopeList.length > 0">
                  已选标签{{ rangePermission.getPersonTypes(scopeList).tags}}个,
                  已选用户{{ rangePermission.getPersonTypes(scopeList).users}}个,
                  已选人员{{ rangePermission.getPersonTypes(scopeList).members}}个,
                  已选部门{{ rangePermission.getPersonTypes(scopeList).depts}}个
                  <!--span v-for="item in scopeList" :key="item.id" style="background: none; height: 36px; line-height: 36px; text-align: center; width: auto; margin-bottom: 0; margin-left: 0;">{{item.name}}</span-->
                </dd>
              </dl>
              <!--/指定人员--></td>
          </tr>
          <tr class="tita">
            <td class="left_td">其他设置</td>
            <td>&nbsp;</td>
          </tr>
          <!--<tr>
            <td class="left_td">学时：</td>
            <td><input name="stime" type="radio" value="0" v-model="stime" @click="changePeriod('0')"/>
              关闭　　
              <input name="stime" type="radio" value="1" v-model="stime" @click="changePeriod('1')"/>
              开启　　
              <label class="timeLabel" v-show="stime=='1'">
                <input name="period" class="put_num" type="text"  v-model="params.period" />
                学时 &lt;!&ndash;<span class="text_12">完成后学员获得的积分奖励</span>&ndash;&gt;
              </label>
            </td>
          </tr>-->
          <tr>
            <td class="left_td">顺序学习：</td>
            <td>
              <input name="study" type="radio" value="1" v-model="params.isOrder"/>
              是　　　
              <input name="study" type="radio" value="0" v-model="params.isOrder"/>
              否</td>
          </tr>
          <tr>
            <td class="left_td">设置积分：</td>
            <td style="position: relative">
              <input type="text" name="score" placeholder="请输入整数" v-model="params.score" class="put_100"/>
              <!--<div class="error_msg_tip"  style="margin-bottom:8px;">{{ errors.first('form.score') }}</div>-->
            </td>
          </tr>
          <tr>
            <td class="left_td">是否收费：</td>
            <td ><input name="money" :disabled="noEdit" type="radio" value="1" v-model="money" @click="changePrice('1')"/>
              是　　　
              <input name="money" :disabled="noEdit" type="radio" value="0" v-model="money" @click="changePrice('0')"/>
              否　　
              <label class="moneyLabel" v-show="money=='1'">　
                <input name="price" type="text" :disabled="noEdit" class="put_num" v-model="params.coursePriceList[0].price" />
                元</label>
            </td>
          </tr>
          <tr>
            <td class="left_td">允许拖动：</td>
            <td>
              <input name="isChangeProgress" type="radio" value="1" v-model="params.isChangeProgress"/>
              允许　　　
              <input name="isChangeProgress" type="radio" value="0" v-model="params.isChangeProgress"/>
              不允许</td>
          </tr>
          <tr>
            <td class="left_td">推送平台：</td>
            <td><input name="isPushPlat" type="radio" value="1" v-model="params.isPushPlat"/>
              是　　　
              <input name="isPushPlat" type="radio" value="2" v-model="params.isPushPlat"/>
              否</td>
          </tr>
        </table>
        <p class="btn_center">
          <input type="button" class="all_btn" value="保存提交" @click="editCourse('form')"/>
        </p>
      </form>
    </div>
    <!--/右侧内容-->
    <!--添加资源-->
    <!--/添加资源-->
    <!--添加课程分类-->
    <div class="tan kcfl_add" style="display:none;">
      <div class="px_add_con">
        <div class="h370 rdiv">
          <h3>添加课程分类</h3>
          <a  href="javascript:void(0);"  class="close" @click="$utils.fadeOut('.kcfl_add'); sort_trigger = null; sort_trigger1 = null;" ></a>
          <span>
            <a @click="editClassification('f', null, '', '0', '0')"  class="add2"></a>
          </span>
          <div class="h295" id="zy_menu_left" style="overflow-x:hidden;height:300px;">
            <dl class="main_menu" v-for="(item, idx) in CCTree" :key="item.id">
            <span>
              <dt class="total-scope">
                <a v-if="sort_trigger !== idx" style="cursor: pointer;" title="点击排序" @click="sort_trigger = idx">{{item.sort}} - </a>
                <span v-if="sort_trigger == idx" >
                  <input type="text" v-model="item.sort" placeholder="排序" style="width: 50px;">
                  <a style="cursor: pointer; border-radius: 5px; padding: 3px; box-sizing: border-box; background: #ff3633; color: white;" @click="classification = item; submitClassification(item.name, item.sort); sort_trigger = null;">保存</a>
                </span>
                {{item.name}}
                <a href="javascript:void(0);" @click="editClassification('s', null, '', item.id, item.parentIds)" class="addSub" title="添加子类"></a>
                <i class="edit"  @click="editClassification('f', item.name, item.id, item.parentId, item.parentIds, item.sort)"></i>
                <a href="javascript:;" @click="delCC(item.id)"><i class="del main_menu_del"></i></a><i class="up_icon icon_c"></i>
              </dt>
              <!--此处字数请程序控制不超过7个汉字-->
              <ul class="ul1 total-scope-tan subUL">
                <!--dd v-for="n in item.nodes" :key="n.id" v-dragging="{ item: n, list: item.nodes, sortType: 'name_s_sort' }"-->
                <dd v-for="(n, idx) in item.nodes" :key="n.id">
                  <a v-if="sort_trigger1 !== idx" style="cursor: pointer;" title="点击排序" @click="sort_trigger1 = idx">{{n.sort}} - </a>
                  <span v-if="sort_trigger1 == idx" >
                    <input type="text" v-model="n.sort" placeholder="排序" style="width: 50px;">
                    <a style="cursor: pointer; border-radius: 5px; padding: 3px; box-sizing: border-box; background: #ff3633; color: white;" @click="classification = n; submitClassification(n.name, n.sort); sort_trigger1 = null;">保存</a>
                  </span>
                  <a href="javascript:;">{{n.name}}</a>
                  <i class="edit" @click="editClassification('s', n.name, n.id, n.parentId, n.parentIds, n.sort)"></i>
                  <a href="javascript:;" @click="delCC(n.id)"><i class="del delSub"></i></a>
                </dd>
              </ul>
            </span>
            </dl>
          </div>
        </div>
        <div class="clear"></div>
        <div class="w240 wrap mt30">
          <input type="button" value="确定" class="all_btn" @click="$utils.fadeOut('.kcfl_add'); sort_trigger = null; sort_trigger1 = null;" />
          <input type="button" value="取消" @click="$utils.fadeOut('.kcfl_add'); sort_trigger = null; sort_trigger1 = null;" class="all_btn color_hui" />
        </div>
      </div>
    </div>
    <!--/添加课程分类-->
    <!--添加大类弹出-->
    <div class="tan add_b_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt style="height: 45px;">
            <input name="" type="text"  v-model="name_f" placeholder="请输入大类名称"/>
          </dt>
          <dt style="height: 95px;">
            <input name="" type="text" v-model="name_f_sort" placeholder="请输入排序"/>
          </dt>
          <dd>
            <input name="" type="button" value="取消" @click="$utils.fadeOut('.add_b_menu')" />　　
            <input name="" type="button" value="确定" class="red_color" @click="submitClassification(name_f, name_f_sort)" /></dd>
        </dl>
      </div>
    </div>
    <!--/添加大类弹出-->
    <!--添加子类弹出-->
    <div class="tan add_s_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt style="height: 45px;">
            <input name="" type="text"  v-model="name_s" placeholder="请输入子类名称"/>
          </dt>
          <dt style="height: 95px;">
            <input type="text" v-model="name_s_sort" placeholder="请输入排序"/>
          </dt>
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.add_s_menu')" />　　<input name="" type="button" value="确定" class="red_color" @click="submitClassification(name_s, name_s_sort)" /></dd>
        </dl>
      </div>
    </div>
    <!--/添加子类弹出-->
  </div>
</template>
<script>

  import {init} from '@/assets/js/public'
  import Dropdown from '@/store/modules/dropdowns'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  import UploadOSSElem from '@/components/upload/uploadOSSbyElem'
  import Ueditor from '@/components/common/UE/ue'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import Vue from 'vue'
  import VueDND from 'awe-dnd'
  import resourceSelect from '@/page/byl/org/resource/select.vue'
  import teacherSelect from '@/page/byl/org/teacher/select.vue'
  import ExamSelect from '@/page/byl/org/examination_paper/select.vue'
  import ModalBox from '@/components/common/modal/index.vue'
  import rangeManip from '@/components/byl/rangeManip/index.vue'
  import difference from 'lodash.differenceby'
  import Bus from '@/utils/bus'
  import utils from '@/utils'
  import rangePermission from '@/utils/rangePermission'
  import { mapActions, mapState } from 'vuex'
  Vue.use(VueDND)
  export default {
    components: { Treeselect, UploadOSS, UploadOSSElem, Ueditor, teacherSelect, VueDND },
    data () {
      return {
        rangePermission:  rangePermission,
        Dropdown: Dropdown,
        filter: {
          pageNo: 1,
          pageSize: this.$global.paginationOptions.page_num,
          type: ''
        },
        list: [],
        pages: 0,
        options: [],
        CCTree: [],

        name_f: '',
        name_s: '',
        name_f_sort: '0',
        name_s_sort: '0',
        sort_trigger: null,
        sort_trigger1: null,

        dragged_item: {},

        classification: {},
        dat: {
          content: ''
        },
        ueditor: {
          value: '',
          config: {
            initialFrameWidth: 790,
            initialFrameHeight: 227
          }
        },
        params: {
          coursePriceList: [{price: 0}]
        },
        money: '0',
        // stime: '0',
        currentRCIds: [],
        currentRCs: [],
        currentEs: [],
        currentChapterList: [],
        chapterName: '',
        currentTCIds: [],
        teacherList: [],
        publicStateList: [], // 推送范围人员列表
        scopeList: [], // 可见范围列表
        prefix: this.$route.meta.prefix || '',
        uploadOSSConf: { showMode: '1', style: 'img_upload2', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null },
        uploadOSSConf_C: { tiptxt: '最多上传三个文件, 一次上传文件的文件请不要超过1G', typeArr: 'image/jpeg, image/png, audio/*, video/mp4, application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.ms-excel, application/vnd.ms-works, application/msword, application/octet-stream, application/zip', catalog: 'resource', fileName: '', maxSize: '1048576', STS: null },
        uploadFiles: [],
        tmpUe: undefined,
        noEdit: false
      }
    },
    created () {
      if (this.$route.params.id === 'create') {
        this.params = {
          chapterList: [],
          teacherList: [],
          coursePriceList: [{price: 0}],
          courseClassifiId: null,
          score: '0',
          publicState: '0',
          scope: '2',
          isOrder: '1',
          isPushPlat: '2',
          online: '1',
          isChangeProgress: '1'
        }
      } else {
        this.currentChapterList = []
        this.getCourse(this.$route.params.id).then((r) => {
          if (r.learnCount > 0) {
            this.noEdit = true
          }
          rangePermission.getRange(this.$route.params.id, '00', this.params.publicState).then((r) => {  // 获取推送范围
            this.publicStateList = r
          })
          rangePermission.getScope(this.$route.params.id, '00', this.params.scope).then((r) => { // 获取可见范围
            this.scopeList = r
          })
        })
      }
      this.getCourseClassification()
    },
    mounted () {
      this.$nextTick(() => {
        init()
      })
      this.getSTS()
      this.OSSUploadSuccess()
      Bus.$on('selectedResources', (data) => {
        // this.params.chapterList = this.dealCurRCData(data)
        this.getResourceListByIds(data)
      })
      Bus.$on('selectedExams', (data) => {
        // this.params.chapterList = this.dealCurEData(data)
        this.getExamListByIds(data)
      })
      Bus.$on('selectedTeachers', (data) => {
        this.currentTCIds = data
        this.getTeacherListByIds(this.currentTCIds)
      })
      /* this.$dragging.$on('dragged', ({ value }) => {
        this.dragged_item = value.list // 拖动保存需要后台支持
      }) */
    },
    watch: {
      'currentEs': {
        handler (val) {
          this.handleChapters(val)
        },
        deep: true
      },
      'currentRCs': {
        handler (val) {
          this.handleChapters(val)
        },
        deep: true
      }
    },
    computed: {
      ...mapState('auth', ['user']),
      isEdit () {
        return this.$route.params.id && this.$route.params.id !== 'create'
      },
      scrollBox () {
        let styles = {'display': 'block', 'height': '500px', 'overflow-y': 'scroll'}
        return this.currentChapterList.length > 3 ? styles : ''
      }
    },
    methods: {
      handleChapters (val) {
        let a =  difference(val, this.currentChapterList, 'id')
        this.currentChapterList = this.currentChapterList.concat(a)
        if (this.params.chapterList.length == this.currentChapterList.length) {
          // console.log('排序前原始list： ', this.params.chapterList)
          // console.log('需要排序的list： ', this.currentChapterList)
          let resultArr = this.sortTwoArr(this.params.chapterList, this.currentChapterList)
          this.currentChapterList = resultArr
        }
        this.chapterName = ''
      },
      sortTwoArr (arr1, arr2) {
        var resultArr = []
        for (let i = 0; i < arr1.length; i++) {
          let o = arr1[i]
          let businessId;
          if (o.sourceList) { businessId = o.sourceList[0].sourceId }
          if (o.examList) { businessId = o.examList[0].examId }
          for (let j = 0; j < arr2.length; j++) {
            let o2 = arr2[j]
            if (o2.businessId == businessId) {
              resultArr.push(o2)
            }
          }
        }
        return resultArr
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: false,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      clickCallback (pageNum) {
        this.filter.pageNo = pageNum
        this.getResources(this.filter)
      },
      changePrice (val) {
        if (val == '0') {
          this.params.coursePriceList[0].price = '0'
        }
        this.money = val
      },
      returnContent () {
        this.dat.content = this.$refs.ue.getUEContent()
        return this.dat.content
      },
      setContent (str) {
        this.ueditor.value = this.$refs.ue.setUEContent(str)
      },
      OSSUploadSuccess (r) {
        if (r && r != '') {
          this.$set(this.params, r.dom_id, r.res.requestUrls[0])
        }
      },
      OSSUploadCSuccess (r) {
        if (r && r != '') {
          this.uploadFiles.push({
            name: r.name.split('/')[2],
            url: r.res.requestUrls[0]
          })
        }
      },
      getCourse (id) {
        return new Promise((resolve, reject) => {
          this.$api.getRestful(this.$global.courseApiPath, '/course/get/' + id, {}, r => {
            resolve(r.data)
            this.params = r.data
            if (this.params.teacherList) {
              this.teacherList = this.params.teacherList
            }
            if (this.params.introduction) {
              this.setContent(this.params.introduction)
            }
            if (this.params.attachment) {
              let f = this.params.attachment.split(',')
              f.forEach((o) => {
                let obj = {
                  name: o.split('|')[0],
                  url: o.split('|')[1]
                }
                this.uploadFiles.push(obj)
              })
            }
            if (this.params.coursePriceList && this.params.coursePriceList.length != 0) {
              if (this.params.coursePriceList[0].price != '0') {
                this.money = '1'
              } else {
                this.money = '0'
              }
            } else {
              this.params.coursePriceList = [{price: 0}]
              this.money = '0'
            }
            /* if (this.params.period && this.params.period != '0') {
              this.stime = '1'
            } else {
              this.stime = '0'
            } */
            if (this.params.chapterList && this.params.chapterList.length) { // 处理章节里的examList和sourceList
              var ids = []
              var ids2 = []
              for (let i = 0; i<this.params.chapterList.length; i++) {
                let o = this.params.chapterList[i]
                var cur = {}
                if (o.sourceList) {
                  cur = {
                    id: this.params.chapterList[i].sourceList[0].sourceId,
                    name: this.params.chapterList[i].name
                  }
                  ids.push(cur)
                  //  this.currentRCIds.push(cur)
                } else if (o.examList) {
                  cur = {
                    id: this.params.chapterList[i].examList[0].examId,
                    name: this.params.chapterList[i].name
                  }
                  ids2.push(cur)
                }
                // this.currentRCIds.push(curRC)
              }
              if (ids.length > 0) {
                this.getResourceListByIds(ids)
              }
              if (ids2.length > 0) {
                this.getExamListByIds(this.$utils.grabVal(ids2, 'id'), ids2)
              }
            }
            if (this.params.teacherList && this.params.teacherList.length) {
              for (let i = 0; i<this.params.teacherList.length; i++) {
                this.currentTCIds.push(this.params.teacherList[i].teacherId)
              }
              this.getTeacherListByIds(this.currentTCIds)
            }
          })
        })
      },
      dealCurRCData (arr) { // 单独处理资源List
        let chapterList = []
        if (arr && arr.length>0) {
          for (let i = 0; i<arr.length; i++) {
            let chapter = {
              name: arr[i].name,
              allHour: arr[i].length,
              sourceList: [
                {
                  sourceId: arr[i].id
                }
              ]
            }
            chapterList.push(chapter)
          }
        }
        return chapterList
      },
      dealCurEData (arr) { // 单独处理测验List
        let chapterList = []
        if (arr && arr.length>0) {
          for (let i = 0; i<arr.length; i++) {
            let chapter = {
              name: arr[i].name,
              examList: [
                {
                  examId: arr[i].id
                }
              ]
            }
            chapterList.push(chapter)
          }
        }
        return chapterList
      },
      dealCurChapterData (arr) { // 处理测验List + 资源List = 章节List
        let chapterList = []
        if (arr && arr.length>0) {
          for (let i = 0; i<arr.length; i++) {
            var chapter;
            if (arr[i].type == '4') {
              chapter = {
                name: arr[i].name,
                examList: [
                  {
                    examId: arr[i].id
                  }
                ]
              }
            } else {
              chapter = {
                name: arr[i].name,
                allHour: arr[i].length,
                sourceList: [
                  {
                    sourceId: arr[i].id
                  }
                ]
              }
            }
            chapterList.push(chapter)
          }
        }
        return chapterList
      },
      dealCurTCData (arr) {
        let teacherList = []
        if (arr && arr.length>0) {
          for (let i = 0; i<arr.length; i++) {
            let teacher = {
              teacherId: arr[i].id,
              teacherName: arr[i].name
            }
            teacherList.push(teacher)
          }
        }
        return teacherList
      },
      editCourse (scope) {
        var self = this
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            self.confirmBox({
              yes: function () {
                if (self.params.online=='0') {
                  self.params.chapterList = []
                } else if (self.params.online=='1') {
                  self.params.chapterList = self.dealCurChapterData(self.currentChapterList)
                  for (let i=0; i<self.params.chapterList.length; i++) {
                    self.params.chapterList[i].number = i + 1;
                  }
                }
                self.params.teacherList = self.dealCurTCData(self.teacherList)
                self.params.introduction = self.returnContent()
                self.params.createName = (self.user) ? self.user.nickname : ''

                if (self.uploadFiles && self.uploadFiles.length > 0) {
                  var arr = []
                  self.uploadFiles.forEach((o) => {
                    arr.push(o.name + '|' + o.url)
                  })
                  self.params.attachment = utils.arr2str(arr)
                } else {
                  self.params.attachment = ''
                }
                self.$api.post(self.$global.courseApiPath, '/course/edit', self.params, r => {
                  if (self.$route.params.id == 'create') {
                    self.$toasted.show('课程创建成功！', {
                      duration: 1000
                    })
                    rangePermission.saveTo(r.data.id, '00', {type: self.params.publicState, value: self.publicStateList}, {type: self.params.scope, value: self.scopeList})
                    self.$router.push({path: self.prefix +  '/org/courseList'})
                  } else {
                    self.$toasted.show('课程修改成功！', {
                      duration: 1000
                    })
                    rangePermission.saveTo(self.params.id, '00', {type: self.params.publicState, value: self.publicStateList}, {type: self.params.scope, value: self.scopeList})
                    self.$router.push({path: self.prefix + '/org/courseList'})
                  }
                })
              }
            })
          } else {
            self.$toasted.show('请确保信息正确与完整！', {
              duration: 800
            })
            return false
          }
        })
      },
      handleRemove(params) {
        let idx = utils.findElem(this.uploadFiles, 'uid', params.uid)
        this.uploadFiles.splice(idx, 1)
      },
      handlePreview (params) {
        let aLink = document.createElement('a')
        aLink.setAttribute('download', params.url)
        aLink.setAttribute('href', params.url)
        aLink.click()
      },
      getSTS () {
        this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
          let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
          this.uploadOSSConf.STS = STS
          this.uploadOSSConf_C.STS = STS
        })
      },
      createIds (arr) {
        var r = []
        for (var i = 0; i < arr.length; i++) {
          let s = arr[i]
          var _pushId = function () {
            if (s.itemId) {
              r.push(s.itemId)
            } else {
              r.push(s.id)
            }
          }
          _pushId()
        }
        return r
      },
      showResourceSelect () {
        if ($.trim(this.chapterName) !== '') {
          var that = this
          if (!this.params.chapterList) {
            this.params.chapterList = []
          }
          var a = that.currentChapterList.filter((o, i) => {
            return o.type !== '4'
          })
          var b = that.dealCurRCData(a) // 为了再次选择时过滤掉已选的资源
          this.$modal.show(resourceSelect, {
            // data: that.params.chapterList,
            data: b,
            chapterName: that.chapterName
          })
        } else {
          this.$toasted.show('请先填写章节名称！', {
            duration: 800
          })
        }
      },
      showExamSelect () {
        if ($.trim(this.chapterName) !== '') {
          var that = this
          var a = that.currentChapterList.filter((o, i) => {
            return o.type == '4'
          })
          var excludeIds = this.createIds(a)
          if (!this.params.chapterList) {
            this.params.chapterList = []
          }
          this.$modal.show(ExamSelect, {
            ids: excludeIds,
            isQuiz: true
          })
        } else {
          this.$toasted.show('请先填写章节名称！', {
            duration: 800
          })
        }
      },
      /* 课程分类 */
      dealTree (arr) {
        var dealArr = []
        if (arr && arr.length>0) {
          for (var i = 0; i< arr.length; i++) {
            var temp = {
              id: arr[i].id,
              label: arr[i].name
            };
            if (arr[i].nodes && arr[i].nodes.length > 0) {
              temp.children = []
              for (var j = 0; j < arr[i].nodes.length; j++) {
                var child = {
                  id: arr[i].nodes[j].id,
                  label: arr[i].nodes[j].name
                }
                temp.children.push(child)
              }
            }
            dealArr.push(temp)
          }
        }

        return dealArr
      },
      addCC () {
        this.$utils.fadeIn('.kcfl_add')
        this.getCourseClassification()
      },
      // 编辑大分类
      editClassification (type, name, id, parentId, parentIds, sort) {
        if (type == 'f' && name == null) {
          this.$utils.fadeIn('.add_b_menu')
          this.name_f = ''
          this.name_f_sort = ''
        } else if (type == 's' && name == null) {
          this.$utils.fadeIn('.add_s_menu')
          this.name_s = ''
          parentIds = parentIds + ','+parentId
          this.name_s_sort = ''
        } else if (type == 'f' && name != null) {
          this.$utils.fadeIn('.add_b_menu')
          this.name_f = name
          this.name_f_sort = sort
        } else if (type == 's' && name != null) {
          this.$utils.fadeIn('.add_s_menu')
          this.name_s = name
          this.name_s_sort = sort
        }
        this.classification = {
          id: id,
          name: name,
          parentId: parentId,
          parentIds: parentIds,
          sort: sort
        }
      },
      submitClassification (name, sort) {
        if (name && name != '') {
          this.classification.name = name
          this.classification.sort = sort
          this.$api.post(this.$global.courseApiPath, '/course/classification/edit', this.classification, r => {
            this.classification = {}
            this.getCourseClassification()
            this.$utils.fadeOut('.add_b_menu')
            this.$utils.fadeOut('.add_s_menu')
          })
        }
      },
      delCC (id) {
        this.$api.getRestful(this.$global.courseApiPath, '/course/classification/delete/' + id, {}, r => {
          this.getCourseClassification()
        })
      },
      getCourseClassification () {
        this.$api.post(this.$global.courseApiPath, '/course/classification/list', {}, r => {
          let tree = r.data
          this.CCTree = tree
          this.options = this.dealTree(tree)
        })
      },
      delRSelectedId (ids, chapterList, id) {
        for (var i = 0; i<ids.length; i++) {
          if (ids[i].id === id) {
            ids.splice(i, 1);
          }
          // if (chapterList[i].sourceList[0].sourceId === id) {
          //   chapterList.splice(i, 1);
          // }
        }
      },
      getResourceListByIds (idsArr) {
        let idStr = ''
        if (idsArr && idsArr.length>0) {
          for (var i = 0; i<idsArr.length; i++) {
            if (i<idsArr.length-1) {
              idStr += idsArr[i].id + ','
            } else if (i == idsArr.length-1) {
              idStr += idsArr[i].id
            }
          }
        }
        this.$api.get(this.$global.resourceApiPath, '/resource/batch', {ids: idStr}, r => {
          this.currentRCs = r.data
          for (var m = 0; m<this.currentRCs.length; m++) {
            for (var n = 0; n<idsArr.length; n++) {
              if (idsArr[n].id === this.currentRCs[m].id) {
                this.currentRCs[m].name = idsArr[n].name
                this.currentRCs[m].businessId = idsArr[n].id
              }
            }
          }
        })
      },
      getExamListByIds (ids, idsArr) {
        this.$api.post(this.$global.examApiPath, '/examPaper/search', {type: '0', idList: this.$utils.arr2str(ids)}, r => {
          this.currentEs = r.data
          for (var m = 0; m<this.currentEs.length; m++) { // 给每一个课程对象赋值“考卷”
            if (idsArr) {
              for (var n = 0; n<idsArr.length; n++) {
                if (idsArr[n].id === this.currentEs[m].id) {
                  this.currentEs[m].name = idsArr[n].name
                  this.currentEs[m].businessId = idsArr[n].id
                }
              }
            } else {
              this.currentEs[m].name = this.chapterName // 将考试的名称改为章节的名称
            }
            this.currentEs[m].type = '4'
            this.currentEs[m].cover = this.currentEs[m].faceUri
          }
        })
      },
      getTeacherListByIds (idsArr) {
        let idStr = ''
        if (idsArr && idsArr.length>0) {
          for (var i = 0; i<idsArr.length; i++) {
            if (i<idsArr.length-1) {
              idStr += idsArr[i] + ','
            } else if (i == idsArr.length-1) {
              idStr += idsArr[i]
            }
          }
        }
        this.$api.get(this.$global.teacherApiPath, '/teacher/batch', {ids: idStr}, r => {
          this.teacherList = r.data
        })
      },
      addTeacher (ids) {
        this.$modal.show(teacherSelect, {
          ids: ids
        })
      },
      delTSelectedId (ids, id) {
        for (let i = 0; i<ids.length; i++) {
          if (ids[i] === id) {
            ids.splice(i, 1);
          }
        }
        for (let i = 0; i<this.teacherList.length; i++) {
          if (this.teacherList[i].id === id) {
            this.teacherList.splice(i, 1)
          }
        }
      },
      showRange () {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '设置推送范围',
            styles: {
              width: '960',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'range',
              template: rangeManip,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: that.publicStateList // 向组件内传入的数据, 一般用于初始化
            },
            yes (val) { // 点击确认后要做的事情
              that.publicStateList = val
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
              if (that.$route.params.id == 'create') {
                that.publicStateList = []
              }
            }
          }
        })
      },
      showScope () {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '设置可见范围',
            styles: {
              width: '960',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'range',
              template: rangeManip,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: that.scopeList // 向组件内传入的数据, 一般用于初始化
            },
            yes (val) { // 点击确认后要做的事情
              that.scopeList = val
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
              if (that.$route.params.id == 'create') {
                that.scopeList = []
              }
            }
          }
        })
      },
      toSource (t, id) {
        let path = (t == '2') ? '/org/resource' : '/org/examPaper'
        this.$router.push({path: this.prefix +  path + '/' + id})
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/course/model.vue